import React, { Component } from 'react'
import Web3 from 'web3'
import './cssTicket.css';
import utils from './../../library'
import Icons from '../Icons/Icons'



class Ticket1_0 extends Component {
constructor(props){
    super()
    this.componentDidMount = this.componentDidMount.bind(this)
    this.state={enabled_items:[],disabled_items:[]}
}

async enableNow(){
    this.props.reset()
    let addr=this.props.address
    let db=this.props.box
    await window.ethereum.enable().then(async function (accounts) {   
        const happybox = utils.happybox(db) 
        await happybox.methods.set(addr,true,3).send({gas: 123456, from: accounts[0]})
    })
    this.props.reset()
}

async disableNow(){
    let addr=this.props.address
    let db=this.props.box
    await window.ethereum.enable().then(async function (accounts) {   
        const happybox = utils.happybox(db) 
        await happybox.methods.set(addr,false,3).send({gas: 123456, from: accounts[0]})
    })
    this.props.reset()
}

    componentDidMount(){
        this.loadMeta()
    }

    async loadMeta(){
        let addr=this.props.address
        await window.ethereum.enable().then(async function (accounts) {
            let metafound=false
            let mtdt
            mtdt=await utils.metadata(addr,addr)         
            if(mtdt.length>0){
                console.log("MTDT",mtdt)
                fetch(utils.formatURL(mtdt)).then(response => response.json()).then(
                response => {
                    console.log(JSON.stringify(response))
                    let back=response[0]["image"]
                    if(back=="")back='https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/27592dd5-bdf2-4e90-9e17-852077de3dd0/d2aytcz-fd1a408a-541d-465d-9f8d-9c662b5ba6db.jpg/v1/fill/w_900,h_600,q_75,strp/fading_blue_grunge_by_dyingbeautystock.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwic3ViIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl0sIm9iaiI6W1t7InBhdGgiOiIvZi8yNzU5MmRkNS1iZGYyLTRlOTAtOWUxNy04NTIwNzdkZTNkZDAvZDJheXRjei1mZDFhNDA4YS01NDFkLTQ2NWQtOWY4ZC05YzY2MmI1YmE2ZGIuanBnIiwid2lkdGgiOiI8PTkwMCIsImhlaWdodCI6Ijw9NjAwIn1dXX0.JSbyhtv1aQd2O8AzG2x1UTZLfyNdtwGNtNSgzKCDFTE'
                    document.getElementById("Ticket_mini_banner").style.backgroundImage='url('+back+')'
                    document.getElementById("Ticket_mini_banner").style.border="solid 1px white"
                })
            }
        }) 
}

    render(props){
    console.log(props)
    let addr="https://etherscan.io/address/"+this.props.address
    let b=this.props.enabled
    if(b){
        return ( <div>
        <div className="Ticket_Modules dark darkblue text white" onClick={() => this.props.ticket(this.props.address,this.props.index)}>                        
            <span className="Ticket_module_icon"><div className="Ticket_link" onClick={() => window.open(addr)}><Icons icon="ticket" d="50"/></div> #{this.props.index} ticket 1.0</span> 
            <div id="Ticket_mini_banner" className="Ticket_mini_banner"></div>  
                        <div className="clear"></div>
                        <div className="Ticket_desc text white">accepts payment in ETH</div>
                        
                        <div className="Ticket_module_install_button light lightblue text white" onClick={() => this.disableNow()}><Icons icon="disable" d="50"/><div className="button_label_right"> disable</div></div>              
                    </div>
                </div>         
        );
    }else{
            return ( <div>
                <div className="Ticket_Modules_disabled dark darkblue text white">                        
                                <span className="Ticket_module_icon"><Icons icon="ticket" d="50"/> #{this.props.index} ticket 1.0</span> 
                                <div className="clear"></div>
                                <div className="Ticket_desc">accepts payment in ETH</div>
                               
                                <div className="Ticket_module_install_button light lightblue text white" onClick={() => this.enableNow()}><Icons icon="thunder" d="40"/><div className="button_label_right"> enable</div></div>              
                            </div>
                        </div>         
                );   
        }
    }
}
     
const web3 = new Web3(Web3.givenProvider || "http://localhost:8545")

export default Ticket1_0